import ApexChart from 'react-apexcharts';
import type { ChartProps } from './types';
import './styles.css';
import Box, { type BoxProps } from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from '@tyro/i18n';
import { LoadingPlaceholderContainer } from '../loading-placeholder';

export function Chart({
  sx,
  type,
  series,
  height,
  options,
  width = '100%',
  isLoading = false,
  ...other
}: BoxProps & ChartProps & { isLoading?: boolean }) {
  const { t } = useTranslation(['common']);
  const hasSeries = Array.isArray(series) && series.length > 0;
  return (
    <Box
      sx={{
        width,
        height,
        flexShrink: 0,
        borderRadius: 1.5,
        position: 'relative',
        ...sx,
      }}
      {...other}
    >
      <LoadingPlaceholderContainer isLoading={isLoading}>
        {hasSeries ? (
          <ApexChart
            type={type}
            series={series}
            options={options}
            width={
              typeof width === 'string' || typeof width === 'number'
                ? width
                : '100%'
            }
            height={
              typeof height === 'string' || typeof height === 'number'
                ? height
                : '100%'
            }
          />
        ) : (
          <Stack
            sx={{
              position: 'absolute',
              height: '100%',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            spacing={1}
          >
            <img
              src="/assets/emojis/bar_chart.png"
              role="presentation"
              alt={t('common:barChart')}
              width="48"
            />
            <Typography variant="body1" component="span" color="text.secondary">
              {t('common:noDataAvailable')}
            </Typography>
          </Stack>
        )}
      </LoadingPlaceholderContainer>
    </Box>
  );
}
